/**
 * The extended Duration / Work display contract (three decimals, unit
 * abbreviations in cells, one accepted unit per input) is always on:
 * no feature flags (PDR-0141, delivery rule DLV-01). A Day / Hour portfolio
 * still renders exactly as before (see isExtendedDisplay).
 */
export const isDisplayUnitsExtended = () => true;
